<!-- 获取停车场图片信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KKN885S",
                "updateTimeFrom":"20190101000000",
                "updateTimeTo":"20190501000000",

            },
            responseCode: {
                "data": {
                    "parkList": [
                        {
                            "address": "佛山市南海区桂平西路6号",
                            "area": "",
                            "fixedCarports": 80,
                            "flagTag": "testTag",
                            "freeTime": 10,
                            "gpsx": 113.165496,
                            "gpsy": 23.038753,
                            "lastUpdateTime": "20190308103210",
                            "mpgsRemainPostionNum": 0,
                            "parkChargeRulePicUrl": "http://ake-parking-devlop.oss-cn-shenzhen.aliyuncs.com/clound-oss/aomp/chargeRuleImg/756f6932-9d06-499f-9d69-ff57b3f296bc.jpg",
                            "parkCode": "2KKN885S",
                            "parkName": "昌俊停车场",
                            "parkPicUrl": "http://ake-parking-devlop.oss-cn-shenzhen.aliyuncs.com/clound-oss/aomp/aompOldImg/2018/08/30/parking_pic_3424.png",
                            "parkSysType": 0,
                            "parkType": 0,
                            "parkingSupervisor": "在这种",
                            "parkingSupervisorPhone": "13425730812",
                            "pkGlobalid": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                            "remainPostionNum": 116,
                            "slotsnumber": 380,
                            "stopConnectPlatform": 1,
                            "tempCarports": 300,
                            "timeoutlength": 1,
                            "type": 0,
                            "validStatus": 0,
                            "wechatIds": "9,2"
                        }
                    ],
                    "total": 1
            },"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车场全部信息",
                t_url: this.commonUrls.test+"getALLParkInfo",
                p_url: this.commonUrls.prod+"getALLParkInfo",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'updateTimeFrom', info2: '否', info3: 'String', info4: '更新起始时间，yyyyMMddHHmmss。若填，最后更新时间需在该值（含）之后' },
                        { info1: 'updateTimeTo', info2: '否', info3: 'String', info4: '更新结束时间，yyyyMMddHHmmss。若填，最后更新时间需在该值（含）之前' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'parkList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'parkList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkPicUrl', info2: '是', info3: 'String', info4: '车场图片链接' },
                        { info1: 'parkChargeRulePicUrl', info2: '是', info3: 'Integer', info4: '车场缴费规则图片链接' },
                        { info1: 'lastUpdateTime', info2: '是', info3: 'String', info4: '最后更新时间，yyyyMMddHHmmss' },
                        { info1: 'address', info2: '是', info3: 'String', info4: '地址' },
                        { info1: 'slotsnumber', info2: '是', info3: 'Integer', info4: '停车位数' },
                        { info1: 'gpsx', info2: '是', info3: 'Decimal', info4: '经度（高德地图坐标）' },
                        { info1: 'gpsy', info2: '是', info3: 'Decimal', info4: '纬度（高德地图坐标）' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '状态ID,0路内 1路外' },
                        { info1: 'pkGlobalid', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'remainPostionNum', info2: '是', info3: 'Integer', info4: '出入口剩余车位数' },
                        { info1: 'mpgsRemainPostionNum', info2: '是', info3: 'Integer', info4: '引导系统剩余车位数' },
                        { info1: 'area', info2: '是', info3: 'String', info4: '区域名称' },
                        { info1: 'timeoutlength', info2: '是', info3: 'Integer', info4: '缴费后离场时间' },
                        { info1: 'tempCarports', info2: '是', info3: 'Integer', info4: '临时停车位数' },
                        { info1: 'fixedCarports', info2: '是', info3: 'Integer', info4: '固定车位数' },
                        { info1: 'validStatus', info2: '是', info3: 'Integer', info4: '停车场是否上线智慧停车，1 下线，0 上线' },
                        { info1: 'publishDate', info2: '是', info3: 'String', info4: '首次上线时间' },
                        { info1: 'freeTime', info2: '是', info3: 'Integer', info4: '免费时长' },
                        { info1: 'flagTag', info2: '是', info3: 'String', info4: '停车场标签,方便查询车场信息' },
                        { info1: 'parkType', info2: '是', info3: 'Integer', info4: '停车场类型0商场1住宅2商住一体3医院及枢纽4写字楼5社会公共6其它 7住宅写字楼' +
                            '8 商场写字楼' },
                        { info1: 'stopConnectPlatform', info2: '是', info3: 'Integer', info4: '是否连接平台(上下架)0下架1上架' },
                        { info1: 'parkingSupervisor', info2: '是', info3: 'String', info4: '停车场运营方负责人' },
                        { info1: 'parkingSupervisorPhone', info2: '是', info3: 'String', info4: '停车场运营方负责人电话' },
                        { info1: 'parkSysType', info2: '是', info3: 'Integer', info4: '车场系统类型(0 VEMS停车场，1云停车场)' },
                        { info1: 'wechatAPPIDs', info2: '是', info3: 'String', info4: '适用公众号appId' },
                        { info1: 'areaId', info2: '否', info3: 'String', info4: '停车场所在地区行政代码' },
                        { info1: 'description', info2: '否', info3: 'String', info4: '描述' },
                        { info1: 'email', info2: '否', info3: 'String', info4: '邮箱' },
                        { info1: 'isFree', info2: '否', info3: 'Integer', info4: '是否免费停车场 1免费 0需缴费' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getALLParkInfo.vue